module.exports = __webpack_public_path__ + "img/food.19f7f891.jpg";